import styled, { css } from 'styled-components';

import {
  defaultThemeProp,
  registerIcon,
  StyledIcon,
  readableColor,
  calculateBackgroundAndContrastColor
} from '@pega/cosmos-react-core';
import type { IconName } from '@pega/cosmos-react-core';
import * as minus from '@pega/cosmos-react-core/lib/components/Icon/icons/minus.icon';
import * as clock from '@pega/cosmos-react-core/lib/components/Icon/icons/clock.icon';

import type { ColorTheme, UserAvailability } from './Chat.types';

registerIcon(minus, clock);

export const userAvailabilityTheme: Record<
  UserAvailability,
  { icon?: IconName; color: ColorTheme }
> = {
  available: { color: ['green', 'light'] },
  unavailable: { icon: 'minus', color: ['red', 'medium'] },
  temporarilyUnavailable: { icon: 'clock', color: ['orange', 'light'] }
};

export const StyledStatusIcon = styled.div<{
  userStatus?: UserAvailability;
}>(
  ({
    theme: {
      base: { colors }
    },
    userStatus
  }) => {
    if (!userStatus) {
      return css`
        background-color: transparent;
      `;
    }
    const [colorName, colorVariant]: ColorTheme = userAvailabilityTheme[userStatus].color;
    const bgColor = colors[colorName][colorVariant];
    const fgColor = readableColor(bgColor);
    return css`
      background-color: ${bgColor};
      color: ${fgColor};
    `;
  }
);

StyledStatusIcon.defaultProps = defaultThemeProp;

export const StyledUserStatusIcon = styled(StyledStatusIcon)(({ theme }) => {
  const navBg = theme.components['app-shell'].nav.background;
  const navFgColor = theme.components['app-shell'].nav['foreground-color'];
  const { backgroundColor } = calculateBackgroundAndContrastColor(navBg, navFgColor);

  return css`
    border-radius: 50%;
    border: 0.0625rem solid ${backgroundColor};

    ${StyledIcon} {
      display: block;
      width: 100%;
      margin: 0 auto;
    }
  `;
});

StyledUserStatusIcon.defaultProps = defaultThemeProp;

export const StyledChatControlPanelIcon = styled(StyledStatusIcon)`
  ${StyledUserStatusIcon} {
    position: absolute;
    width: 0.875rem;
    height: 0.875rem;
    z-index: 1;
    inset-block-start: -0.25rem;
    inset-inline-end: -0.25rem;
  }
`;
